/**
 * Templates "create new" route.
 *
 * Path: /_authenticated/templates/new
 * Layout (MainLayout, sidebar) inherited from _authenticated parent.
 *
 * Renders the TemplateBuilder pre-filled with BLANK_TEMPLATE so the user
 * starts with a sensible SOAP scaffold they can rename + reshape.
 */

import { createFileRoute, Link } from '@tanstack/react-router';

import { TemplateBuilder } from '../../components/templates/TemplateBuilder';
import { MainLayoutContent, MainLayoutHeader } from '../../components/layout/MainLayout';
import { Icon } from '../../components/ui/Icon';
import { SidebarNavIcons } from '../../components/ui/Icon/generalIcons';
import { usePlanFeature } from '../../hooks/usePlanFeature';

const TemplatesNewRouteComponent = () => {
  const customTemplates = usePlanFeature('user_custom_templates');

  return (
    <MainLayoutContent>
      <MainLayoutHeader
        title="New Template"
        subtitle="Build a custom note template for your encounters."
        breadcrumbs={[
          { label: 'Home', href: '/home', icon: <Icon icon={SidebarNavIcons.Home} size="sm" /> },
          {
            label: 'Templates',
            href: '/templates',
            icon: <Icon icon={SidebarNavIcons.Templates} size="sm" />,
          },
          { label: 'New' },
        ]}
      />
      {!customTemplates.allowed ? (
        <div className="rounded border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900">
          Custom templates are a Pro feature.{' '}
          <Link to="/billing/checkout" className="underline">
            Upgrade your plan
          </Link>{' '}
          to build and share your own.
        </div>
      ) : (
        <TemplateBuilder />
      )}
    </MainLayoutContent>
  );
};

export const Route = createFileRoute('/_authenticated/templates/new')({
  component: TemplatesNewRouteComponent,
});
